// Imports
import Alpine from 'alpinejs';
import { gsap } from "gsap";

// Project imports
import Header from "@js/modules/Header";

class JdlToggle {
    constructor() {
        // Set up Alpine store to control nav toggle
        Alpine.store('jdl', {
            isOpen: false,
            toggle() {
                if (this.isOpen) {
                    this.close();
                }
                else {
                    this.open();
                }
            },
            open() {
                // Open nav
                this.isOpen = true;

                // Scroll to top when opening
                window.scrollTo({ top: 0, behavior: 'smooth' });

                gsap.fromTo(document.querySelector('.jdl-content'),
                    {
                        'margin-top': window.innerWidth < 1024 ? '-365px' : '-475px',
                    }, {
                        duration: 0.5,
                        ease: 'power2.out',
                        'margin-top': 0,
                        onComplete: () => {
                            Header.init();
                        }
                    }
                );

                let jdlCarousel = document.querySelector('.jdl-carousel');
                let jdlCarouselItems = jdlCarousel.querySelectorAll('.flickity-cell');
                gsap.fromTo(jdlCarouselItems,
                    {
                        opacity: 0,
                    }, {
                        delay: 0.25,
                        duration: 0.4,
                        opacity: 1,
                        stagger: 0.1,
                    }
                );

                gsap.to(document.querySelector('.jdl-btn-arrow'), {
                    display: 'none',
                    duration: 0,
                });
            },
            close() {
                // Close nav
                this.isOpen = false;

                gsap.to(document.querySelector('.jdl-content'), {
                    'margin-top': window.innerWidth < 1024 ? '-365px' : '-475px',
                    duration: 0.5,
                    ease: "power2.in",
                    onComplete: () => {
                        Header.init();

                        let jdlCarousel = document.querySelector('.jdl-carousel');
                        let jdlCarouselItems = jdlCarousel.querySelectorAll('.flickity-cell');
                        gsap.to(jdlCarouselItems,
                            {
                                opacity: 0,
                                duration: 0.2,
                            }
                        );

                        // Focus the button for valid accessibility
                        document.body.focus();
                    }
                });

                gsap.to(document.querySelector('.jdl-btn-arrow'), {
                    display: 'block',
                    delay: 0.4,
                    duration: 0.2,
                });
            }
        });

        // Handle resize
        window.addEventListener('resize', () => {
            Alpine.store('jdl').close();
        });
    }
}

export default new JdlToggle();